export { invokeCallback, pTimeout } from '@segment/analytics-core';
//# sourceMappingURL=index.js.map